function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
var _excluded = ["bodyWrapperProps", "children", "className", "closeButtonProps", "heading", "headingWrapperProps", "icon", "iconProps", "iconWrapperProps", "labels", "look", "messageWrapperProps", "onClose", "showClose", "showHeading", "showIcon"],
  _excluded2 = ["look"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { useState, useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import "../../../../enums/accordion.js";
import { AlertLooks } from "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import { FontIcons } from "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import { baseAlertStyle, getAlertTheme } from "../../../../styles/styled-components/alert.js";
import "../../../../styles/styled-components/animations.js";
import "../../../../styles/styled-components/box-shadow.js";
import "../../../../styles/styled-components/button.js";
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import { fontFamilyMedium } from "../../../../themes/fonts.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import { lightTheme } from "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import "../../../../styles/styled-components/font-face.js";
import "../../../../styles/styled-components/global.js";
import "../../../../styles/styled-components/input.js";
import "../../../../styles/styled-components/list.js";
import "../../../../styles/styled-components/listitem.js";
import "../../../../styles/styled-components/media-queries.js";
import "../../../../styles/styled-components/reset.js";
import "../../../../styles/styled-components/outline.js";
import "../../../../styles/styled-components/popout.js";
import "../../../../styles/styled-components/screen-reader.js";
import "../../../../styles/styled-components/switch.js";
import "../../../../styles/styled-components/tooltip.js";
import '@brandfolder/utilities';
import { CloseButton } from "../../button/close-button/close-button.js";
import "../../button/color-button/color-button.js";
import "../../../../utilities/color.js";
import 'date-fns';
import "../../../../utilities/locale.js";
import "../../../../hooks/use-prevent-keyboard-scrolling.js";
import "../../tooltip/hover-tooltip/hover-tooltip.js";
import { FontIcon } from "../../icon/font-icon/font-icon.js";
import 'react-laag';
import 'react-transition-group';
import "../../button/icon-button/icon-button.js";
import "../../button/standard-button/standard-button.js";
import "../../loader/circle-loader/circle-loader.js";
import "../../loader/shimmer-loader/shimmer-loader.js";
import { BaseAlert } from "../base-alert/base-alert.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var BaseStandardAlert = function BaseStandardAlert(props) {
  var _classnames;
  var bodyWrapperProps = props.bodyWrapperProps,
    children = props.children,
    className = props.className,
    closeButtonProps = props.closeButtonProps,
    heading = props.heading,
    headingWrapperProps = props.headingWrapperProps,
    icon = props.icon,
    iconProps = props.iconProps,
    iconWrapperProps = props.iconWrapperProps,
    _props$labels = props.labels,
    labels = _props$labels === void 0 ? {} : _props$labels,
    look = props.look,
    messageWrapperProps = props.messageWrapperProps,
    onClose = props.onClose,
    _props$showClose = props.showClose,
    showClose = _props$showClose === void 0 ? false : _props$showClose,
    _props$showHeading = props.showHeading,
    showHeading = _props$showHeading === void 0 ? true : _props$showHeading,
    _props$showIcon = props.showIcon,
    showIcon = _props$showIcon === void 0 ? true : _props$showIcon,
    otherProps = _objectWithoutProperties(props, _excluded);
  var closeButtonLabel = labels.closeButtonLabel;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    closed = _useState2[0],
    setClosed = _useState2[1];
  var getIcon = function getIcon() {
    if (icon) return icon;
    switch (look) {
      case AlertLooks.Error:
        {
          return FontIcons.Alert;
        }
      case AlertLooks.Success:
        {
          return FontIcons.CheckMarkCircle;
        }
      case AlertLooks.Warning:
        {
          return FontIcons.Warning;
        }
      default:
        {
          // AlertLooks.None
          return null;
        }
    }
  };
  var fontIcon = getIcon();
  var handleClose = function handleClose() {
    setClosed(true);
    if (onClose) onClose();
  };
  if (closed) return null;
  return /*#__PURE__*/React.createElement(BaseAlert, _extends({}, otherProps, {
    className: classnames((_classnames = {
      'bf-alert__standard': true
    }, _defineProperty(_classnames, "bf-alert__standard--".concat(look), look !== AlertLooks.None), _defineProperty(_classnames, 'bf-alert__standard--has-close-button', showClose), _defineProperty(_classnames, 'bf-alert__standard--has-heading', showHeading), _defineProperty(_classnames, 'bf-alert__standard--has-icon', showIcon), _defineProperty(_classnames, "".concat(className), !!className), _classnames))
  }), showIcon && fontIcon && /*#__PURE__*/React.createElement("div", _extends({}, iconWrapperProps, {
    className: classnames(_defineProperty({
      'bf-alert__icon': true
    }, "".concat(iconWrapperProps === null || iconWrapperProps === void 0 ? void 0 : iconWrapperProps.className), !!(iconWrapperProps !== null && iconWrapperProps !== void 0 && iconWrapperProps.className)))
  }), /*#__PURE__*/React.createElement(FontIcon, _extends({}, iconProps, {
    icon: fontIcon,
    iconSize: (iconProps === null || iconProps === void 0 ? void 0 : iconProps.iconSize) || 18
  }))), /*#__PURE__*/React.createElement("div", _extends({}, bodyWrapperProps, {
    className: classnames(_defineProperty({
      'bf-alert__body': true
    }, "".concat(bodyWrapperProps === null || bodyWrapperProps === void 0 ? void 0 : bodyWrapperProps.className), !!(bodyWrapperProps !== null && bodyWrapperProps !== void 0 && bodyWrapperProps.className)))
  }), heading && showHeading && /*#__PURE__*/React.createElement("div", _extends({}, headingWrapperProps, {
    className: classnames(_defineProperty({
      'bf-alert__heading': true
    }, "".concat(headingWrapperProps === null || headingWrapperProps === void 0 ? void 0 : headingWrapperProps.className), !!(headingWrapperProps !== null && headingWrapperProps !== void 0 && headingWrapperProps.className)))
  }), heading), /*#__PURE__*/React.createElement("div", _extends({}, messageWrapperProps, {
    className: classnames(_defineProperty({
      'bf-alert__message': true
    }, "".concat(messageWrapperProps === null || messageWrapperProps === void 0 ? void 0 : messageWrapperProps.className), !!(messageWrapperProps !== null && messageWrapperProps !== void 0 && messageWrapperProps.className)))
  }), children)), showClose && closeButtonLabel && /*#__PURE__*/React.createElement(CloseButton, _extends({}, closeButtonProps, {
    "aria-label": closeButtonLabel,
    icon: FontIcons.XCirlce,
    onClick: function onClick() {
      handleClose();
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        handleClose();
      }
      if (closeButtonProps !== null && closeButtonProps !== void 0 && closeButtonProps.onKeyUp) {
        closeButtonProps === null || closeButtonProps === void 0 || closeButtonProps.onKeyUp(e);
      }
    }
  })));
};
var Alert = styled(BaseStandardAlert)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  display: flex;\n\n  .bf-alert__body {\n    flex: 1 1 0%;\n  }\n\n  .bf-alert__heading {\n    font-family: ", ";\n    font-size: 16px;\n    line-height: 1.4;\n    margin-bottom: 5px;\n  }\n\n  .bf-alert__icon {\n    flex-shrink: 0;\n    margin-top: 1px;\n    margin-inline-end: 10px;\n    min-width: 0;\n  }\n\n  .bf-alert__message {\n    white-space: normal;\n  }\n\n  .bf-button__close {\n    align-self: flex-start;\n    flex-shrink: 0;\n    margin: -4px -4px -4px 0;\n    padding: 4px;\n\n    .bf-button__close-icon {\n      font-size: 22px;\n    }\n  }\n"])), baseAlertStyle, function (_ref) {
  var look = _ref.look;
  return getAlertTheme({
    look: look
  });
}, fontFamilyMedium);
var StandardAlert = function StandardAlert(props) {
  var _props$look = props.look,
    look = _props$look === void 0 ? AlertLooks.Warning : _props$look,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(Alert, _extends({}, otherProps, {
    look: look
  })));
};
export { StandardAlert };